
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const PreviewHeader = () => {
  const navigate = useNavigate();

  return (
    <>
      <Button variant="ghost" onClick={() => navigate("/refund")} className="mb-4">
        <ArrowLeft className="mr-2 h-4 w-4" /> Back to Request Form
      </Button>
      
      <div className="bg-amber-100 text-amber-800 rounded-lg p-3 mb-6 flex items-center">
        <div className="bg-amber-200 p-1.5 rounded-md mr-2">
          <span className="text-xs font-bold uppercase tracking-wider">Preview Mode</span>
        </div>
        <p className="text-sm">
          You're viewing a preview. Sign up to save this refund request and access all features!
        </p>
      </div>
    </>
  );
};

export default PreviewHeader;
